import { render, staticRenderFns } from "./WorkRegistrationList.vue?vue&type=template&id=7f28c452&"
import script from "./WorkRegistrationList.vue?vue&type=script&lang=js&"
export * from "./WorkRegistrationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports